// Variations on a message that may apply in special cases
export enum MessageVariant {
	FrequentOutages = 'FrequentOutages',
	EngineeringWork = 'EngineeringWork',
}
export interface MessageDetail {
	description?: string;
	code: string;

	// Single line summary
	summary?: string;

	message?: string;

	// Shorter message (if needed for Mobile / SMS)
	shortMessage?: string;

	// Details meant to be displayed on screen
	details?: string;

	// Details meant to be read out loud
	audioDetails?: string;

	// Data specific to an individual channel
	channelDataLookupsStringified?: string;
	channelData?: object;

	icon?: string;
	style?: string;

	// Any variations on the message
	variants?: Partial<Record<MessageVariant, Partial<MessageDetail>>>;

	// Used to disable a specific message code
	disabled?: boolean;

	// Use to pick which message code takes priority over others
	priority?: number;
}
